export var Name = 'follow-us-item-click';
export var FollowUsItemClick = Name;